var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", { style: _vm.componentStyle }, [
    _c(
      "span",
      {
        class: `size-${_vm.size} display-inline-flex flex-row flex-items-center`,
        style: `gap: var(--spacing-${_vm.spacing})`,
      },
      _vm._l(_vm.length, function (index) {
        return _c("font-awesome-icon", {
          key: index,
          staticClass: "fa-width-auto",
          attrs: { icon: _vm.$v7.solid[_vm.iconName] },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }